import React, { useState, useEffect } from 'react'
import './gazette.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp, faArrowLeft, faArrowRight, faRotate } from '@fortawesome/free-solid-svg-icons'
import { Link, useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import * as Constants from '../../constants';


function MapGazette() {
    const navigate = useNavigate();
    const {categoryid} = useParams()
    const [selectedRows, setSelectedRows] = useState(new Set());
    
    const [selectedItems, setSelectedItems] = useState({});
    const [gazettes, setGazettes]=useState ([]);
    const [mapGazette, setMapGazettes]=useState ([]);
    const [specs,setSpecs]=useState([]);
    // const [collapse, setCollapse] = useState(false)
    const [collapsedCat, setCollapsedCat] = useState({})
    const [isLoading,setIsLoading]= useState(false);
    const [signs,setSigns] =useState([]);

    const [ serverMap, setServerMap]= useState(new Set());
    const catObj=Constants.CategoryList.filter((cat) => cat.id ==categoryid)[0];

    const check = (id, row) => {
      
        const updatedSelectedRows = new Set(selectedRows);
        const updatedSelectedItems = { ...selectedItems };

        // Toggle the selection state for the clicked row
        if (updatedSelectedRows.has(id)) {
            updatedSelectedRows.delete(id);
            delete updatedSelectedItems[id];
            //check if item is on server already
            if(serverMap.has(id)){
                //delete on server
                onDeleteMap(id);
            }

        } else {
            updatedSelectedRows.add(id);
            updatedSelectedItems[id] = row;
        }

        setSelectedRows(new Set(updatedSelectedRows));
        setSelectedItems(updatedSelectedItems);


    };

    const dummyCategory = [
        {
            id: 1,
            name: '(A) For the Recovery of a specified sum',
            items: [
                {
                    itemid: 1,
                    title: 'For the recovery of specified sum (between ₦1 & ₦500,000)',
                    isDocRequired: true,
                    isMoreThanOne: true,
                    amount: 300
                },
                {
                    itemid: 2,
                    title: 'For the recovery of specified sum (between ₦1 & ₦500,000)',
                    isDocRequired: false,
                    isMoreThanOne: false,
                    amount: 250
                },
                {
                    itemid: 3,
                    title: 'For the recovery of specified sum (between ₦1 & ₦500,000)',
                    isDocRequired: true,
                    isMoreThanOne: false,
                    amount: 400
                },
                {
                    itemid: 4,
                    title: 'For the recovery of specified sum (between ₦1 & ₦500,000)',
                    isDocRequired: false,
                    isMoreThanOne: false,
                    amount: 300
                },
                {
                    itemid: 5,
                    title: 'For the recovery of specified sum (between ₦95,000,001 & ₦100,000,000)',
                    isDocRequired: true,
                    isMoreThanOne: true,
                    amount: 300
                },
                {
                    itemid: 6,
                    title: 'For the recovery of specified sum (between ₦95,000,001 & ₦100,000,000)',
                    isDocRequired: true,
                    isMoreThanOne: false,
                    amount: 300
                },
                {
                    itemid: 7,
                    title: 'Statement Of Claim',
                    isDocRequired: true,
                    isMoreThanOne: true,
                    amount: 600
                },
                {
                    itemid: 8,
                    title: 'List of Documents',
                    isDocRequired: true,
                    isMoreThanOne: false,
                    amount: 150
                },
                {
                    itemid: 9,
                    title: 'Declaration',
                    isDocRequired: true,
                    isMoreThanOne: true,
                    amount: 100
                },
                {
                    itemid: 10,
                    title: 'Maximum Fees',
                    isDocRequired: true,
                    isMoreThanOne: false,
                    amount: 300
                },
            ]
        },
   
    ]

    // console.log(selectedItems);

    const totalAmount = Object.values(selectedItems).reduce((sum, item) => sum + item.amount, 0)
    
    const clearItems = () => {
        setSelectedRows(new Set());
        setSelectedItems({});
    } ;

    const goBack = () => {
        clearItems()

        navigate('/mapcategories')
    }

    function isObjectEmpty() {
        return Object.keys(selectedItems).length === 0 && selectedItems.constructor === Object;
    }

    const proceedBtn = () => {

        if (isObjectEmpty()) {
            alert('Please pick items before proceeding')
        } else {
            //save map item
        }
    }

    const toggleCollapse = (id) => {
        setCollapsedCat((prev) => ({
            ...prev,
            [id]: !prev[id]
        }))
    }

    useEffect(() => {
        onLoadGazette()
       // onLoadMaps();
      }, [categoryid]);
      const onLoadGazette= async()=>{
        //for account registration
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/Gazette`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                var currentid=0;
                var gazlist=[];
                //buld dummy 
                data.gazettes.forEach(gaz => {
                 var idx=   gazlist.findIndex( function(el){return el.id==gaz.caseSpecificationId});
                 if(idx==-1){
                    //new specification
                    var idsp= data.specs.findIndex( function(el){return el.caseSpecificationId==gaz.caseSpecificationId});
                   
                    if(idsp==-1){
                        console.log('idsp index '+idsp);
                      //  console.log('cannot find specification for this one');
                      //  console.log(gaz)
                    }else{
                        var spobj={id:data.specs[idsp].caseSpecificationId, name:data.specs[idsp].description, items:[]}
                    spobj.items.push( {
                        itemid: gaz.caseTypeComponentId,
                        title: gaz.componentName,
                        isDocRequired: gaz.isUpload,
                        isMoreThanOne: true,
                        amount: gaz.fee
                    });
                    gazlist.push(spobj);
                    }
                        
                    
                 }else{
                    gazlist[idx].items.push( {
                        itemid: gaz.caseTypeComponentId,
                        title: gaz.componentName,
                        isDocRequired: gaz.isUpload,
                        isMoreThanOne: true,
                        amount: gaz.fee
                    });
                 }

                });
                setSigns(data.signs);
                console.log('constructed dummy');
                console.log(gazlist)
                setGazettes(gazlist);
                onLoadMaps();
            }else {    
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
  const onLoadMaps= async()=>{
        //for account registration
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/Gazette/MapGazette/${categoryid}`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                var mgaz=new Set(data.mMap);
                setSelectedRows(new Set(data.mMap));
                setServerMap(new Set(data.mMap));

            }else {    
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    } 
    const onSaveMap= async()=>{
        //for account registration
        try {
            setIsLoading(true);
            var obj=Array.from(selectedRows);
            const resp = await fetch(`${Constants.apiUrl}/gazette/MapGazette/${categoryid}`, {
              method: 'POST',
              body: JSON.stringify(obj),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0) {
            
             setServerMap(new Set(selectedRows)) ;
             alert("Saved. Thank you Femi...");
            }else {
              
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

    const onDeleteMap= async(mapid)=>{
        //for account registration
        try {
            setIsLoading(true);
            // var obj=Array.from(selectedRows);
            const resp = await fetch(`${Constants.apiUrl}/gazette/MapGazette/${categoryid}/${mapid}`, {
              method: 'DELETE',
            //   body: JSON.stringify(obj),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0) {
             console.log('delete done..........');
  
            }else {
              
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }

  return (
    <div className='gazette-list'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>{catObj?.title}</h2>
                        <button><Link to='/mapcategories'>Change Category</Link></button>
                    </div>
                    <p>Select items related to the case that you are filing</p>
                </div>
                <p className="nav-status">Home/Specifications</p>
            </div>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Select Specification</th>
                            <th>Specification</th>
                            <th>Document Required</th>
                            <th>Document Quantity</th>
                        </tr>
                    </thead>
                    {gazettes.length>0 &&
                        gazettes.map((item, id) => { return (
                            <tbody key={id} className={collapsedCat[id] ? 'collapse' : ''}>
                                <tr>
                                    <td className='span' colSpan='3'>
                                        {item.name}
                                    </td>
                                    <td className='span'>
                                        <div className="icon" onClick={() => toggleCollapse(id)}>
                                            <FontAwesomeIcon icon={collapsedCat[id] ? faAngleDown : faAngleUp } />
                                        </div>
                                    </td>
                                </tr>   
                                {
                                    item.items.map((row, idx) => { return (
                                        <tr className={selectedRows.has(row.itemid) ? 'specific-row picked' : 'specific-row'} key={idx}>
                                            <td>
                                                <input 
                                                    type="checkbox" 
                                                    className='check'
                                                    id={row.itemid}
                                                    onClick={() => check(row.itemid, row)}
                                                    checked={selectedRows.has(row.itemid)}
                                                    // defaultChecked={selectedRows.has(row.itemid)}

                                                />
                                            </td>
                                            <td className='specification'>{row.itemid} - {row.title}</td>
                                            <td className='document-upload'>
                                                {row.isDocRequired ? <p>Yes</p> : ''}
                                            </td>
                                            <td className='quantity'>
                                                {
                                                    (false) ? <input type="number" className='number' id='numOfdocs' disabled={!selectedRows.has(row.itemid)}/> : ''
                                                }
                                            </td>
                                        </tr>
                                    )})
                                }
                            </tbody>
                        )})
                    }
                </table>
                <div  className="table-container">
                    
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Description</th>
                                <th>Applied To</th>
                                <th>Fee</th>
                                <th>Qty</th>
                                <th>Document Required</th>
                            </tr>
                        </thead>
                        <tbody  className={ ''}>
                        <tr>
                                    <td className='span' colSpan='5'>
                                    Specifications
                                    </td>
                                    <td className='span'>
                                        <div className="icon" >
                                           
                                        </div>
                                    </td>
                                </tr>   
                            {signs?.length>0 && signs.map((item, idx) =>{return (
                            <tr key={idx}  className={ 'specific-row'} >
                            <td>
                               
                             </td>
                            <td> {item.caseSignFeeId} - {item.desciption}</td>
                            <td>{item.appliesTo}</td>
                            <td>{item.fee}</td>
                            <td className='quantity'></td>
                            <td className='document-upload'>
                                                 <p>Yes</p> 
                            </td>
                        </tr>)})}
                        </tbody>
                        
                    </table>
            </div>
            </div>
            <div className="total-pay">
                <div className="reset-back">
                    <div className="back" onClick={() => goBack()}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <p>Back</p>
                    </div>
                    <button onClick={() => clearItems()}>Reset Selection <FontAwesomeIcon icon={faRotate} /></button>
                </div>
                <div className="total-fee">
                    <p className="total">Total Item Selected: <span>{selectedRows.size}</span></p>
                
                    <button onClick={() => onSaveMap()}>Save <FontAwesomeIcon icon={faArrowRight} /></button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MapGazette